import React from 'react';
import clsx from 'clsx';

import { Element } from '@shared/interfaces/element.interface';

import avatarPlaceholderImage from '@assets/images/avatar-placeholder.png';

interface AvatarProps extends Element {
  url: string | null;

  placeholder?: string | null;

  size?: number;

  alt?: string;

  loading?: 'lazy';
}

export const Avatar: React.FC<AvatarProps> = ({
  url,
  className,
  size = 120,
  alt = 'Avatar',
  placeholder = avatarPlaceholderImage,
  loading,
}) => {
  const avatarUrl = url ? url : placeholder ? placeholder : null;
  if (!avatarUrl) {
    return null;
  }

  return (
    <figure className={clsx('avatar', className)} style={{ width: `${size}px`, height: `${size}px` }}>
      <img className="avatar__image" src={avatarUrl} alt={alt} loading={loading} />
    </figure>
  );
};
